<template>
  <div class="SectionProjects">
    <CardPortfolioLandowner isShortSubtitle v-for="portfolio in portfolios" :key="portfolio.id" :portfolio="portfolio" />
  </div>
</template>

<script>
import CardPortfolioLandowner from './CardPortfolioLandowner'
import { getters } from 'views/utils'

export default {
  components: { CardPortfolioLandowner },
  props: {
    isLandingLandowner: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      locationNamesIt: [
        'Slesia, Polonia',
        'Podlaskie, Polonia',
        'Lubusz, Polonia',
        'Pomerania, Polonia',
      ],
    }
  },
  computed: {
    limit() {
      if (!this.isLandingLandowner) return 2
      return this.locale === 'pl' ? 5 : 4
    },
    portfolios() {
      const query = {
        $sort: { id: 1 },
        $limit: this.limit,
      }

      const portfolios = this.query('portfolio', query)

      return this.locale === 'pl'
        ? portfolios
        : portfolios.map((portfolio, index) => ({
          ...portfolio,
          location: this.locationNamesIt[index],
        }))
    },
    ...getters(),
  },
}
</script>

<style lang="scss">
.SectionProjects {
  margin: 2rem 0;
}
</style>
